import { ExternalLink, MapPin } from "lucide-react";

import { CopyButton } from "components/ui/copy-button";
import { buttonVariants } from "components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

export function CoordinatesToGoogle({ position }) {
  const coords = `${position.lat},${position.lng}`;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${coords}`;

  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:text-xs tw:text-(--color-text-muted)">
      <MapPin className="tw:size-3.5 tw:shrink-0" />
      <span id={coords}>
        {position.lat.toFixed(4)}, {position.lng.toFixed(4)}
      </span>
      <div className="tw:flex tw:items-center tw:gap-1.5">
        <CopyButton
          targetId={coords}
          size="icon-xs"
          tooltipMessage="Copy coordinates"
        />
        <Tooltip>
          <TooltipTrigger
            render={
              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open in Google Maps"
                className={buttonVariants({
                  variant: "outline",
                  size: "icon-xs",
                })}
              >
                <ExternalLink />
              </a>
            }
          />
          <TooltipContent>Open in Google Maps</TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
}
